import { CallAPI } from '../../utils/util';
import {useLocation, useParams} from "react-router-dom";
import { HistoryData } from '../../utils/components'
import React, { Component } from "react";
import { PatientNav } from './patientnav';

function withRouter(Component) {
    function ComponentWithRouterProp(props) {
        let location = useLocation();
        let params = useParams();

        return (
            <Component
                {...props}
                router={{ location, params }}
            />
        );
    }
    return ComponentWithRouterProp;
}

class RecordData extends Component {
    constructor(props) {
        super(props);
        this.state = {
            "patientID": this.props.router.params.patientId,
            "rows": [],
            "res": {
                "name": "",
                "questions": []
            }
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    handleSubmit(event) {
        CallAPI(this.state, `patients/${this.state.patientID}/labReports`, 'PUT')
    }

    handleChange(event, id) {
        event.preventDefault();
        this.setState((state) => {
            let rows = state.rows
            rows[event.target.id-1] = {
                "questionID": id,
                "value": event.target.value
            }
            return {"rows": rows}
        })
    }

    componentDidMount() {
        if(this.props.router.params.question_id !== "confirm") {
            CallAPI({}, `labs/${this.props.router.params.question_id}/details`, 'GET', (res) => {
                this.setState({"res": res})
            })
        }
    }

    render = () => {
        return (
            <div>
                <PatientNav patientId={this.state.patientID} />
                <HistoryData res={this.state.res} component={this} question={this.props.router.params.question_id}/>
            </div>
        )
    };
}
  
export default withRouter(RecordData)